import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { getDownloadURL, ref, listAll } from 'firebase/storage';
import { storage } from "../../../firebase/firebaseConfig";

const ListaMisVideosDashboard = () => {
    const [videoUrls, setVideoUrls] = useState([]); // Estado para almacenar las URLs de los videos
    const [loading, setLoading] = useState(true);   // Estado para manejar la carga

    // Función para obtener los videos desde Firebase Storage
    useEffect(() => {
      const fetchVideos = async () => {
        try {
          // Referencia a la carpeta de videos en Firebase Storage
          const listRef = ref(storage, 'misvideospagecalocho/');

          // Obtener todos los archivos de la carpeta
          const res = await listAll(listRef);

          // Obtener las URLs de cada archivo
          const urls = await Promise.all(
            res.items.map(async (itemRef) => {
              const url = await getDownloadURL(itemRef);
              return url;
            })
          );

          // Actualizar el estado con las URLs obtenidas
          setVideoUrls(urls);
        } catch (error) {
          console.error('Error obteniendo los videos:', error);
        } finally {
          setLoading(false);  // Finalizar la carga
        }
      };

      fetchVideos();
    }, []); // Se ejecuta una vez cuando el componente se monta

    return(
        <Box>
        <Grid container spacing={2}>
          {loading ? (
            <Typography variant="h6">Cargando videos...</Typography>
          ) : videoUrls.length > 0 ? (
            videoUrls.map((url, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <video
                  src={url}
                  autoPlay
                  loop
                  muted
                  controls
                  style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                  }}
                >
                  Tu navegador no soporta el elemento de video.
                </video>
              </Grid>
            ))
          ) : (
            <Typography variant="h6" margin={'60px'}>No hay videos para mostrar</Typography>
          )}
        </Grid>
      </Box>
    );
}

export default ListaMisVideosDashboard;